module.exports = __webpack_public_path__ + "img/mytarget-img-1.f3a3c8da.jpg";